import defineCustomElement from '../../define-custom-element.js';

import TpTextAreaFilled from './tp-text-area-filled.js';
import TpTextAreaFilledLight from './tp-text-area-filled-light.js';
import TpTextAreaOutlined from './tp-text-area-outlined.js';

import TpTextFieldFilled from './tp-text-field-filled.js';
import TpTextFieldFilledLight from './tp-text-field-filled-light.js';
import TpTextFieldOutlined from './tp-text-field-outlined.js';

defineCustomElement('tp-text-area-filled', TpTextAreaFilled);
defineCustomElement('tp-text-area-filled-light', TpTextAreaFilledLight);
defineCustomElement('tp-text-area-outlined', TpTextAreaOutlined);

defineCustomElement('tp-text-field-filled', TpTextFieldFilled);
defineCustomElement('tp-text-field-filled-light', TpTextFieldFilledLight);
defineCustomElement('tp-text-field-outlined', TpTextFieldOutlined);

export {
  TpTextAreaFilled,
  TpTextAreaFilledLight,
  TpTextAreaOutlined,
  TpTextFieldFilled,
  TpTextFieldFilledLight,
  TpTextFieldOutlined,
}
